import { Menu, Transition } from '@headlessui/react';
import clsx from 'clsx';
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  File,
  TrendingUp,
  Globe,
  Shield,
  User,
  Bug,
  HelpCircle,
} from 'lucide-react';
import { useTheme } from 'hooks/useTheme';

export const HelpMenuNavigation = () => {
  const { theme, background } = useTheme();

  return (
    <Menu as="div" className="ml-3 relative z-50">
      {({ open }) => (
        <>
          <Menu.Button>
            <div className="relative p-2 mt-2 rounded-full bg-white/10 hover:scale-105 backdrop-blur-md transition">
              <HelpCircle size={20} className="text-white" />
            </div>
          </Menu.Button>

          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              static
              className={`origin-top-right absolute right-0 mt-2 w-72 rounded-xl p-4 backdrop-blur-md shadow-xl ring-1 ring-white/10 focus:outline-none ${theme}`}
            >
              {/* Background overlay if set */}
              {background && (
                <div className="absolute inset-0 pointer-events-none opacity-10 z-0">
                  <img
                    src={background}
                    alt="Background overlay"
                    className="w-full h-full object-cover"
                  />
                </div>
              )}

              {/* Links Section */}
              <div className="relative z-10 text-left space-y-1">
                {[
                  { label: 'Documentation', to: '/docs/learn', icon: File },
                  { label: 'System Updates', to: '/app/updates', icon: TrendingUp },
                ].map(({ to, icon: Icon, label }) => (
                  <Menu.Item key={to}>
                    {({ active }) => (
                      <Link
                        to={to}
                        className={clsx(
                          'flex items-center px-3 py-2 rounded-md text-sm transition-all',
                          active ? 'bg-white/10 text-white' : 'text-white/80 hover:bg-white/10'
                        )}
                      >
                        <Icon className="w-4 h-4 mr-2" />
                        {label}
                      </Link>
                    )}
                  </Menu.Item>
                ))}

                <hr className="my-3 border-t border-white/10" />

                {[
                  { label: 'Terms of Service', to: '/sys/legal/terms-of-service', icon: Globe },
                  { label: 'Privacy Policy', to: '/sys/legal/privacy-policy', icon: Shield },
                  { label: 'Customer Acceptance', to: '/sys/legal/customer-acceptance', icon: User },
                ].map(({ to, icon: Icon, label }) => (
                  <Menu.Item key={to}>
                    {({ active }) => (
                      <Link
                        to={to}
                        className={clsx(
                          'flex items-center px-3 py-2 rounded-md text-sm transition-all',
                          active ? 'bg-white/10 text-white' : 'text-white/80 hover:bg-white/10'
                        )}
                      >
                        <Icon className="w-4 h-4 mr-2" />
                        {label}
                      </Link>
                    )}
                  </Menu.Item>
                ))}

                <hr className="my-3 border-t border-white/10" />

                {[
                  { label: 'Report Issue', to: '/app/issues/report-bug', icon: Bug },
                ].map(({ to, icon: Icon, label }) => (
                  <Menu.Item key={to}>
                    {({ active }) => (
                      <Link
                        to={to}
                        className={clsx(
                          'flex items-center px-3 py-2 rounded-md text-sm transition-all',
                          active ? 'bg-white/10 text-white' : 'text-white/80 hover:bg-white/10'
                        )}
                      >
                        <Icon className="w-4 h-4 mr-2" />
                        {label}
                      </Link>
                    )}
                  </Menu.Item>
                ))}
              </div>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
};
